import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarBottom from './NavbarBottom';
import no_image_available from '../images/no_image_available.jpg';

const Ebooklist = () => {

    const [newsList, SetNews] = useState([]);
    const [newsLink, SetNewsLink] = useState([]);
    const [dataToDisplay, setDataToDisplay] = useState([]);

    const urlImg = `${process.env.REACT_APP_BASEURL}/berita/`;

    const handleSearchPageNext = async (e) => {
        //console.log(e);
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/ebook?page=${e}`)
            .then((response) => response.json())
            .then((res) => {
                SetNews(res.data.data);
                //console.log(res.data);
            });
    }

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/ebook`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas);
                SetNews(datas.data.data);
                SetNewsLink(datas.data.links);
            });
    }, []);

    return (
        <div class="max-w-full h-[673px] mx-auto flex flex-col items-center pt-20">
            <h1 class="text-[56px] font-bold text-[#0f0f1c]">Ebook</h1>
            <p class="text-[#888888] text-lg mt-2">Ebook JDIH Kota Magelang</p>

            <div class="flex items-center justify-center lg:h-screen">
                <div class="container mx-auto mx-auto p-4">
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4">
                        {newsList.map((data_news, indexnews_list) => (
                            <div class="bg-white rounded-lg border p-4">                                
                                {data_news?.images != '' ? 
                                    <img src={urlImg + '' + data_news.images} alt="Agenda Image" class="w-full h-48 rounded-md object-cover" />
                                    :
                                    <img src={no_image_available} alt="" />
                                }
                                
                                <div class="px-1 py-4">
                                    <p class="text-gray-700 text-base text-left">
                                        {data_news.title}
                                    </p>
                                </div>
                                <div class="px-1 py-4">
                                    <div class="grid grid-cols-2 gap-2">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
                                            </svg>
                                        </div>
                                        <div>
                                            <Link to={`/detail-ebook/${data_news.id}/${data_news.link}`} class="max-w-sm mx-auto group hover:no-underline focus:no-underline dark:bg-gray-50">
                                                Read More
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ebooklist;
